import requests from './requests';

export default {
    course(id) {
        return requests
            .post(`/coach/share/course/${id}`)
            .then(resp => resp.data);
    },
    trainer(id) {
        return requests
            .post(`/coach/share/trainer/${id}`)
            .then(resp => resp.data);
    },
    invite(date) {
        return requests
            .post(`/coach/share/invite/${date}`)
            .then(resp => resp.data);
    },
};




// WEBPACK FOOTER //
// ./src/api/share.js